const colors = {
  parties: {
    "m-swe": "#2f80ed",
    "sd-swe": "#f2c94c",
    "kd-swe": "#3163a6",
    "l-swe": "#56ccf2",
    "c-swe": "#27ae60",
    "mp-swe": "#219653",
    "s-swe": "#e04b49",
    "v-swe": "#b12827",
    "pp-swe": "#675443",
    "fi-swe": "#c20055",
    oth: "#999999",
    dk: "#333333",
    "moderate-party-swe": "#2f80ed",
    "sweden-democrats": "#f2c94c",
    "christian-democrats-swe": "#3163a6",
    "liberals-swe": "#56ccf2",
    "centre-party-swe": "#27ae60",
    "green-party-swe": "#219653",
    "social-democratic-party-swe": "#e04b49",
    "left-party-swe": "#b12827",
    "pirate-party-swe": "#675443",
    "feminist-initiative-swe": "#c20055",
    "og:moderate-party-swe": "#2f80ed",
    "og:sweden-democrats": "#f2c94c",
    "og:christian-democrats-swe": "#3163a6",
    "og:liberals-swe": "#56ccf2",
    "og:centre-party-swe": "#27ae60",
    "og:green-party-swe": "#219653",
    "og:social-democratic-party-swe": "#e04b49",
    "og:left-party-swe": "#b12827",
    "og:pirate-party-swe": "#675443",
    "og:feminist-initiative-swe": "#c20055",
  },
}

export default colors
